<button
  mat-icon-button
  class="metadata-menu__button"
  type="button"
  (click)="openEditDialog()"
  matTooltipPosition="above"
  [matTooltip]="buttonTooltip"
>
  <mat-icon>edit</mat-icon>
</button>
